<template>
  <div class="content">
    <h2 v-scroll-animate="'animate__fadeInUp'">
      M-NETについて
    </h2>
    <p v-scroll-animate="'animate__fadeInUp'">
      私たち株式会社M-NETは、ITヘルプデスク、システム開発、運用保守、オフショア開発を中心に、多岐にわたるソリューションを提供しています。
    </p>
    <p v-scroll-animate="'animate__fadeInUp'">
      私たちのミッションは、お客様のビジネス課題に最適な答えを提供し、共に成長し続けることです。革新的な技術と柔軟な発想で、新しいビジネスモデルの創出を目指しています。
      また、国内外のネットワークを活用し、グローバル規模でお客様のニーズに対応します。
    </p>
    <p v-scroll-animate="'animate__fadeInUp'">
      これからも「信頼されるパートナー」として、最善のサービスとソリューションを提供し、社会に貢献する企業として邁進してまいります。
      お客様との長期的な協力関係を大切にしながら、新しい未来を共に築いていきたいと考えています。
    </p>
  </div>
</template>

<script>
export default {
    name: "MnetdInfoView"
};
</script>

<style lang="scss" scoped>
.content {
  background: #ffffff;
  width: 100%;
  margin: 20px 0;
  padding: 20px;
}

.content h2 {
  font-size: 36px;
  color: #444444;
  text-align: center;
  margin-bottom: 50px;
  font-weight: normal;
}

.content p {
  font-size: 18px;
  line-height: 1.8;
  color: #666666;
  margin: 0;
}

@media (max-width: 1060px) {
  .content {
    padding: 0 10px;
    max-width: 100%;
    margin-bottom: 50px;
  }

  .content h2 {
    font-size: 24px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .content p {
    font-size: 16px;
  }
}
</style>
